import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { StyledIconButton } from "app/components/React/Table/cells/ExpansionButtonCell";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const EnrichButtonContainer = styled(FlexColumn)`
    ${StyledIconButton} {
        align-self: flex-start;
    }
    align-items: center;
    height: 100%;
`;
export const ExpansionButtonWrapper = styled.div`
    flex: 1;
    min-width: 0;
`;

export const ExpansionTrendButtonWrapper = styled.div`
    .SWReactIcons > svg > path {
        fill: ${colorsPalettes.carbon[300]};
    }
    &:hover {
        .SWReactIcons svg path {
            fill: ${colorsPalettes.blue[500]};
        }
    }
    height: 24px;
    align-items: center;
    display: flex;
`;

export const EnrichAmountUrlWrapper = styled.div`
    ${setFontVariant("input2", colorsPalettes.carbon[400])};
`;

export const CompetitorsWrapper = styled(FlexRow)`
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
`;

export const CompetitorWrapper = styled.span`
    position: relative;
    > div {
        background: ${colorsPalettes.bluegrey[200]};
    }
`;

export const VSWrapper = styled(FlexRow)`
    ${setFontVariant("body1", colorsPalettes.carbon[300])};
    letter-spacing: 0.7px;
    margin-right: 8px;
    margin-left: 8px;
    flex: 0 0 auto;
    height: 32px;
    align-items: center;
`;

export const IconButtonWrapper = styled.div`
    .Button > div {
        svg {
            path {
                fill: ${colorsPalettes.blue[400]};
                fill-opacity: inherit;
            }
        }
    }
`;

export const CompetritoresDropdownWrapper = styled.div`
    width: auto;
`;

export const CompetritoresDropdownItemsWrapper = styled(FlexRow)`
    gap: 8px;
    align-items: center;
`;

export const CompetritoresDropdownItemText = styled.div`
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
`;

export const CompetritoresTooltipItemTitleText = styled.div`
    margin-bottom: 8px;
    ${setFontVariant("captionTitle", colorsPalettes.carbon[250])};
`;

export const CompetritoresTooltipItemText = styled.div`
    margin-bottom: 8px;
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
`;

export const ItemIconChainWrapper = styled.div`
    cursor: pointer;
`;
